<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 103.726 103.726">
  <g>
    <g>
      <g>
        <g>
          <circle cx="30.839" cy="85.361" r="6.537" fill="#70a3e0"/>
          <circle cx="68.496" cy="85.361" r="6.537" fill="#70a3e0"/>
        </g>
        <path d="M30.023,67.606a.946.946,0,0,1-.054-.946l2.993-6.22H72.25a5.378,5.378,0,0,0,5.022-3.454L86.72,32.308a1.792,1.792,0,0,0-1.674-2.433H28.426l-4.21-10.308A5.25,5.25,0,0,0,19.357,16.3h-8.5a3.545,3.545,0,0,0-3.554,2.845,3.421,3.421,0,0,0,3.372,3.993h5.568L28.7,54.84l-4.274,8.88a7.5,7.5,0,0,0-.307,6.064,7.24,7.24,0,0,0,6.737,4.554h43.47A3.136,3.136,0,0,0,77.458,71.2h0a3.136,3.136,0,0,0-3.137-3.136H30.851A.948.948,0,0,1,30.023,67.606Z" fill="#70a3e0"/>
      </g>
      <g>
        <circle cx="81.378" cy="30.915" r="19.087" fill="#fff"/>
        <g>
          <circle cx="81.378" cy="30.915" r="14.433" fill="#005ae9"/>
          <path d="M76.534,30.848c0-4.823,1.884-7.334,4.844-7.334s4.845,2.534,4.845,7.334c0,4.823-1.884,7.469-4.845,7.469S76.534,35.671,76.534,30.848Zm7.222,0c0-4.038-.987-5.316-2.378-5.316C80.01,25.532,79,26.81,79,30.848S80.01,36.3,81.378,36.3C82.769,36.3,83.756,34.886,83.756,30.848Z" fill="#fff"/>
        </g>
      </g>
    </g>
    <rect width="103.726" height="103.726" fill="none"/>
  </g>
</svg>
